export default __webpack_public_path__ + "static/media/card7.3cb1ffae.png";